import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ROUTE_TITLES: Record<string, string> = {
  "/": "Dashboard",
  "/leads": "Leads",
  "/referrals": "Find Referrals",
  "/outreach": "Referral Outreach",
  "/lead-filters": "Lead Filters",
  "/analytics": "Analytics",
  "/analytics-owner": "Owner Analytics",
  "/reports": "Reports",
  "/community": "Community",
  "/quick-intake": "Quick Intake",
  "/embed": "Chatbot Embed",
  "/audit-log": "Audit Log",
  "/settings": "Settings",
  "/team": "My Team",
  "/profile": "My Profile",
  "/tasks": "My Tasks",
  "/admin": "Admin Portal",
  "/landing": "LegacyGrowth Engine",
  "/pricing": "Pricing",
  "/affiliate": "Affiliate Program",
  "/login": "Sign in",
  "/signup": "Create your account",
  "/forgot-password": "Reset password",
  "/check-email": "Confirm your email",
};

const APP_NAME = "LegacyGrowth Engine";

/** Mount once at the App root — keeps the browser tab title in sync with the route. */
export function useDocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const exact = ROUTE_TITLES[pathname];
    const matched = exact
      ?? Object.entries(ROUTE_TITLES)
        .filter(([k]) => k !== "/" && pathname.startsWith(k))
        .sort((a, b) => b[0].length - a[0].length)[0]?.[1];
    document.title = matched ? `${matched} · ${APP_NAME}` : APP_NAME;
  }, [pathname]);
}
